module.exports = __webpack_public_path__ + "media/fonts/TTCommons-DemiBold-c54e68a9a927f1aa620272dd2c2f95e9.woff";